<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
 						<h4 class="mb-3 card-ttl">サイト情報編集</h4>
						<div class="loading"  v-show="loading">受信中...</div>

						<div>

							<div class="form-group" v-bind:class="{  'text-danger has-error': errors.site_name_jp }">
                                  <label for="title">サイト名<span class="badge badge-required">必須</span></label>
                                  <input type="text" v-model="site_name_jp" class="form-control" value="" name="site_name_jp" id="site_name_jp" />
                                    <p v-for="(error,key) in errors.site_name_jp" :key="key" class="error-text" >{{error}}</p>
                              
                              </div>


							<div class="form-group">
                              <label for="site">対象サイト</label>
									<span class="selected-option">{{ selectedSiteData.site_domain }}</span>
                            </div>

							<div class="form-group" v-bind:class="{  'text-danger has-error': errors.timezones }">
                
							<label for="site">タイムゾーン<span class="badge badge-required">必須</span></label>
						<div class="input-group" >
						<select  class="" v-model="timezoneSelected" >
							<option  value="">--</option>
							<option v-for="(n,key) in allTimezones" :key="key" :value="n.offset + '--' + n.jp_text + '--' + n.en_text ">(UTC {{n.offset }} ) {{ n.jp_text }}</option>
						</select>
						</div>
						<p v-for="(error,key) in errors.timezones" :key="key" class="error-text" >{{error}}</p>
						
						</div>

						<div class="form-group" v-bind:class="{  'text-danger has-error': errors.site_name_jp }">
                                  <label for="title">契約プラン<!--<span class="badge badge-required">必須</span>--></label>
                                  <div> <span class="plan-ttl">{{currentPlanName}}</span> <!--<a :href="sitePlanUrl">変更</a>--></div>
                                   
                              
                              </div>

						<div class="btn-wrap form-group text-center">
                  
							<a class="btn btn-primary btn-white" href="/sites">一覧に戻る</a>
							<button  class="btn btn-primary" @click="update"  :disabled="loading" >変更する</button>
                        </div>
							
						</div>
					</div>
                </div>
            </div>

		</div>
	</div>
</template>

<script>

export default {
	components: { },
	props: ['siteData', 'sitePlan'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			siteId:null,
			site_name_jp:"",
			siteList:{},
			selectedSiteData:{},
			selectedSitePlan:{},
			allTimezones:{},
			sitePlanUrl:"",
			currentPlanName: "",
			timezoneSelected: "",
			errors: {},
			loading: false
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;	
		this.selectedSiteData = JSON.parse(this.siteData);
		this.selectedSitePlan =JSON.parse(this.sitePlan);
		this.site_name_jp = this.selectedSiteData.site_name_jp;
        
		
		this.sitePlanUrl = `/site/${this.siteId}/changeplan`;
		this.currentPlanName = this.selectedSitePlan.plan_title;
		this.timezoneSelected = this.selectedSiteData.utcoffset + "--" + this.selectedSiteData.timezone
		this.allTimezones = this.getTimezone();
		
	},

	methods: {
		async getTimezone () {
			const url = '/json/timezones.json';
			const params = { };
			axios.get(url, params)
			.then(response => {
				this.allTimezones = response.data;
			});
		},
		update() {
      this.loading = true;
      this.isSend = 0;
      this.errors = {};
      axios.post(`/site/info/${this.siteId}`, {
        utcoffset : this.timezoneSelected,
		site_name_jp : this.site_name_jp
      }).then(response => {
        this.loading = false;
        this.$toast(response.data.info, {
          toastClassName: "toaster"
        }) 
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
           this.loading = false;
           //this.info = error.response.data.info
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、更新できませんでした。ページをリロードしてください")
        }
      });
	
	}
}
}
</script>

<style scoped>
.selected-option {
	display:block;
	min-width:200px;
}
.copybutton {
	background-color:transparent;
	border:0;
	outline:0;
	cursor:pointer;
	opacity:1;
	position:absolute;
	top: 10px;
	right:10px;
	z-index:9;
	border-radius:24px;
}
.button-tooltip-container {
    display: flex;
    align-items: center;
    margin-top: 16px;
    min-height: 30px;
}

#custom-tooltip {
    display: none;
    margin-left: 40px;
    padding: 5px 12px;
	background-color: rgba(94,118,228, .9);
    border-radius: 4px;
    color: #fff;
	position:absolute;
	right:10px;
	top: -40px;
}

textarea {
	width: 100%;
	height: 200px;
	resize: none;
	border:1px solid #CDD3D9;
}
.opt-val {
	display:block;
	margin-top: 10px;
}

.card {
	max-width: 1024px;
}

.card-body {
	padding: 3.6rem;
}
.plan-ttl {
	display:inline-block;
	margin-right: 20px;
}
</style>